import { render, staticRenderFns } from "./view_mrn.vue?vue&type=template&id=2f73e7e9&scoped=true"
import script from "./view_mrn.vue?vue&type=script&lang=js"
export * from "./view_mrn.vue?vue&type=script&lang=js"
import style0 from "./view_mrn.vue?vue&type=style&index=0&id=2f73e7e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f73e7e9",
  null
  
)

export default component.exports